<template>
	<div>
		<AddSectionModal v-model="form"></AddSectionModal>
		<SectionList v-model="form" v-on:renderIndex="renderIndex"/>
	</div>
</template>

<script>
	import AddSectionModal from "./AddSectionModal";
	import SectionList from "./SectionList";


	export default {
		name: "SectionPanel",
		components: {SectionList, AddSectionModal},
		methods: {
			renderIndex(event) {
				this.$emit("renderIndex", event);
			},
		},
		props: {
			value: Object,
		},

		watch: {
			form: {
				handler() {
					this.$emit("input", this.form);
				}
				,
				deep: true,
			},
		},

		data() {
			return {
				form: this.value,
			};
		},
	};
</script>

<style scoped>

</style>
